var formValidation = require("base/components/formValidation");

module.exports = {
    getGuestReturn: function () {
        $("form.guest-return-form").submit(function (e) {
            var form = $(this);
            // clear browser default behaviour
            e.preventDefault();
            // get action URL
            var actionUrl = form.attr("action");
            form.spinner().start();
            $.ajax({
                url: actionUrl,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $(".alert-danger").hide();

                        if ($(".secure-email-sent").length === 0) {
                            $("body").append(
                                "<div class=\"secure-email-sent\"></div>"
                            );
                        }

                        $(".secure-email-sent").append(
                            "<div class=\"alert secure-email-sent-alert alert-success text-center\" role=\"alert\">"
                            + data.message[0]
                            + "</div>"
                        );

                        setTimeout(function () {
                            $(".secure-email-sent-alert").remove();
                        }, 5000);
                    }

                    // redirect if redirectURL exists
                    if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    }
                }
            });
        });
    }
};
